import { State, createFeatureSelector, createSelector } from "@ngrx/store";
import * as SpinNGoSummariesReducer from './spin-n-go-summaries.reducer';
import * as mainReducers from '@app/store/features/main/main.reducers';

export const selectMainState = createFeatureSelector<mainReducers.MainState>('main');
export const selectSpinNGoState = createSelector(selectMainState, (state) => state.spinNGoSummaries);


export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal,
} = SpinNGoSummariesReducer.adapter.getSelectors(selectSpinNGoState);

export const selectLoader = createSelector(
    selectSpinNGoState,
    (state) => state?.loader
);

export const selectEntityById = (id: number) => createSelector(
    selectEntities,
    (entities) => entities[id]
);
